import React, { useState, useEffect } from "react";
import {
    Card,
    CardContent,
    Typography,
    CircularProgress,
    Box,
    Grid,
} from "@mui/material";
import { db } from "../../firebase";
import { ref, onValue } from "firebase/database";

const BlogsSection = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBlogs = () => {
            const dbRef = ref(db, "blogs");
            onValue(
                dbRef,
                (snapshot) => {
                    const data = snapshot.val();
                    if (data) {
                        const blogsArray = Object.entries(data).map(([id, value]) => ({
                            id,
                            ...value,
                        }));
                        setBlogs(blogsArray);
                    } else {
                        setBlogs([]);
                    }
                    setLoading(false);
                },
                (error) => {
                    console.error("Error fetching blogs:", error);
                    setLoading(false);
                }
            );
        };

        fetchBlogs();
    }, []);

    return (
        <Box
            id="blogs"
            sx={{
                width: "100%",
                margin: "0 auto",
                padding: "40px 20px",
                textAlign: "center",
            }}
        >
            <Typography
                variant="h4"
                gutterBottom
                sx={{
                    fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
                    marginBottom: "20px",
                }}
            >
                Blogs and Posts
            </Typography>

            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <CircularProgress />
                </Box>
            ) : blogs.length > 0 ? (
                <Grid
                    container
                    spacing={3}
                    justifyContent="center"
                    sx={{
                        padding: { xs: "0 10px", sm: "0 20px", md: "0 40px" },
                    }}
                >
                    {blogs.map((blog) => (
                        <Grid
                            item
                            xs={12}
                            sm={6}
                            md={4}
                            key={blog.id}
                        >
                            <Card
                                sx={{
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    borderRadius: "16px",
                                    padding: "20px",
                                    minHeight: "300px", // Set minimum height
                                    minWidth: "250px", // Set minimum width
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    transition: "transform 0.2s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.02)",
                                    },
                                    backgroundColor: "white",
                                }}
                            >
                                <CardContent>
                                    <Typography
                                        variant="h5"
                                        gutterBottom
                                        sx={{
                                            fontSize: { xs: "1.25rem", sm: "1.5rem" },
                                        }}
                                    >
                                        {blog.title}
                                    </Typography>
                                    <Typography
                                        variant="subtitle2"
                                        color="text.secondary"
                                        gutterBottom
                                        sx={{
                                            fontSize: { xs: "0.8rem", sm: "0.9rem" },
                                        }}
                                    >
                                        By {blog.author} on{" "}
                                        {new Date(blog.date).toLocaleDateString()}
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontSize: { xs: "0.9rem", sm: "1rem" },
                                            lineHeight: "1.5",
                                            display: "-webkit-box",
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            WebkitLineClamp: 3,
                                        }}
                                    >
                                        {blog.content}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            ) : (
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                        fontSize: { xs: "1rem", sm: "1.2rem" },
                    }}
                >
                    No blogs available.
                </Typography>
            )}
        </Box>
    );
};

export default BlogsSection;
